<!-- Search input shown at every level (root + every submenu) -->
<div *ngIf="!dynamicDropService.isObjEmpty(data)" class="recursive-search-container"
  (click)="$event.stopPropagation()">
  <mat-form-field appearance="outline" class="recursive-search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
      placeholder="Search..." autocomplete="off" />
    <button mat-icon-button matSuffix *ngIf="searchTerm"
      (click)="clearSearch(); $event.stopPropagation()" aria-label="Clear search">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<ng-container *ngIf="!dynamicDropService.isObjEmpty(data)">
  <ng-container *ngFor="let key of getFilteredKeys()">
    <!-- Execute if data[key] contain childNodes -->
    <ng-container *ngIf="hasChildNodes(data[key])">
      <!-- Button for menu item with submenu -->
      <button mat-menu-item [matMenuTriggerFor]="subMenu" #subMenuTrigger="matMenuTrigger"
        (click)="openSubMenu(subMenuTrigger, $event, key)" [matTooltip]="getToolTip(key)">
        {{ changeDisplayNm(key) }}
      </button>
      <!-- Submenu definition: render a SINGLE recursive component with merged items
           so the submenu has exactly one search box at its top -->
      <mat-menu #subMenu="matMenu">
        <ng-container *ngIf="children[key] as items; else loading">
          <ng-container *ngIf="items.length > 0; else noData">
            <app-dynamic-recursive-menu [data]="mergeItems(items)" [path]="path.concat(key)"
              [childCntrl]="childCntrl" (itemSelected)="itemSelected.emit($event)"></app-dynamic-recursive-menu>
          </ng-container>
          <ng-template #noData>
            <span mat-menu-item class="noData">No data available</span>
          </ng-template>
        </ng-container>
        <ng-template #loading>
          <span mat-menu-item>Loading...</span>
        </ng-template>
      </mat-menu>
    </ng-container>
    <!-- Execute if data[key] didn't contain childNodes -->
    <ng-container *ngIf="!hasChildNodes(data[key])">
      <button mat-menu-item (click)="menuItemSelected(path.concat(key, data[key]), false, key)"
        [matTooltip]="getToolTip(key)">
        {{ changeDisplayNm(key) }}
      </button>
    </ng-container>
  </ng-container>
  <!-- No results when filtering -->
  <span *ngIf="searchTerm && getFilteredKeys().length === 0" mat-menu-item class="noData">
    No matching results
  </span>
</ng-container>
<!-- If the Object length is empty then show no data available option -->
<ng-container *ngIf="dynamicDropService.isObjEmpty(data)">
  <span mat-menu-item class="noData">No data available</span>
</ng-container>